import React from 'react'
import { graphql } from 'gatsby'
import { BlogNav, CategoryHeader, PostGrid, Section, BlogCtaBanner, SEO, WhatsNew } from 'newComponents'
import classNames from 'classnames'
import Layout from '../components/layout.js'
import './category.scss'

const Category = ({ data, location, pageContext }) => {
  const paginationAmount = 12

  const { category, categoryPosts, featuredCategoryPosts } = data
  const { data: pageData } = category
  const { nodes: posts = [] } = categoryPosts
  const { nodes: featuredPosts = [] } = featuredCategoryPosts

  const {
    metaTitle,
    metaDesc,
    ogImage,
    category_name: categoryName,
    category_description: categoryDescription,
    what_s_new_title: whatsNewTitle,
    what_s_new_link_url: whatsNewUrl,
    what_s_new_content: whatsNewContent,
    what_s_new_image: whatsNewImage
  } = pageData

  const suggestedPosts = posts.slice(0, 6)
  const isProductUpdate = categoryName?.text.toLowerCase() === 'product updates'

  // seo data
  const seo = {
    title: metaTitle?.text || `${categoryName?.text}`,
    description: metaDesc?.text || categoryDescription?.text || `Read insightful articles on ${categoryName?.text}`,
    ogImage: ogImage?.url
  }

  return (
    <Layout staticNavbar>
      <SEO {...seo} />
      <div className={classNames('category', { 'category-product-update': isProductUpdate })}>
        <BlogNav />
        <CategoryHeader category={categoryName} description={categoryDescription} isProductUpdate={isProductUpdate} />
        {isProductUpdate && (
          <WhatsNew title={whatsNewTitle} url={whatsNewUrl} content={whatsNewContent} image={whatsNewImage} />
        )}
        <Section className="category-posts-container">
          {featuredPosts.length === 2 && (
            <PostGrid
              posts={featuredPosts}
              title={`Featured ${categoryName.text}`}
              className="category-featured"
              paginationAmount={paginationAmount}
            />
          )}
          {posts.length > 0 && (
            <PostGrid
              posts={posts}
              title={`All ${categoryName.text}`}
              className="grid-variant"
              paginationAmount={paginationAmount}
            />
          )}
        </Section>
        {suggestedPosts.length > 1 && (
          <PostGrid posts={suggestedPosts} title="You May Like" className="suggested-variant" />
        )}
        {!posts || (posts.length < 1 && <span className="category-down-state">No posts found</span>)}
        {/* <BlogCtaBanner /> */}
      </div>
    </Layout>
  )
}

export default Category

export const categoryQuery = graphql`
  query CategoryBySlug($uid: String!) {
    category: prismicCategory(uid: { eq: $uid }) {
      id
      uid
      prismicId
      data {
        metaTitle: meta_title {
          text
        }
        metaDesc: meta_description {
          text
        }
        ogImage: open_graph_image {
          url
        }
        category_description {
          html
          text
        }
        category_name {
          html
          text
        }
        what_s_new_title {
          html
          text
        }
        what_s_new_link_url {
          url
        }
        what_s_new_image {
          url
          localFile {
            childImageSharp {
              fluid(maxWidth: 1200, quality: 90) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
        what_s_new_content {
          html
        }
      }
    }
    categoryPosts: allPrismicBlogPost(
      filter: { data: { categories: { elemMatch: { category: { uid: { eq: $uid } } } } } }
      sort: { order: DESC, fields: data___timestamp }
    ) {
      nodes {
        uid
        id
        data {
          author {
            uid
            document {
              ... on PrismicAuthor {
                uid
                id
                data {
                  author_name {
                    html
                    text
                  }
                }
              }
            }
          }
          featured_image {
            url
          }
          categories {
            category {
              uid
              id
            }
          }
          timestamp(formatString: "MMMM D, YYYY")
          hide_date
          title {
            html
            text
          }
        }
      }
    }
    featuredCategoryPosts: allPrismicBlogPost(
      filter: { data: { categories: { elemMatch: { category: { uid: { eq: $uid } } } } } }
      sort: { order: DESC, fields: data___timestamp }
      limit: 2
    ) {
      nodes {
        uid
        id
        data {
          author {
            uid
            document {
              ... on PrismicAuthor {
                uid
                id
                data {
                  author_image {
                    url
                    localFile {
                      childImageSharp {
                        fluid(maxWidth: 150, quality: 90) {
                          ...GatsbyImageSharpFluid_withWebp
                        }
                      }
                    }
                  }
                  author_name {
                    html
                    text
                  }
                }
              }
            }
          }
          featured_image {
            url
            localFile {
              childImageSharp {
                fluid(maxWidth: 1200, quality: 90) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
          categories {
            category {
              uid
              id
            }
          }
          timestamp(formatString: "MMMM D, YYYY")
          hide_date
          title {
            html
            text
          }
        }
      }
    }
  }
`
